const clean = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
export const estacionesDe = (concesion) =>
  Array.isArray(concesion?.rules?.estaciones_peajes) ? concesion.rules.estaciones_peajes : [];
export function filterConcesiones(concesiones, search) {
  const query = clean(search).trim();
  return concesiones.filter((concesion) =>
    [
      concesion.code,
      concesion.name,
      concesion.rules?.nombre,
      concesion.rules?.politica_pago?.modalidad,
      concesion.rules?.politica_pago?.descripcion_modalidad,
      ...estacionesDe(concesion).map((estacion) => estacion?.peaje),
    ].some((value) => clean(value).includes(query))
  );
}
export function formatPercent(value) {
  if (value === null || value === undefined || value === "" || !Number.isFinite(Number(value)))
    return "—";
  return `${(Number(value) * 100).toLocaleString("es-CO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;
}
export function corteDe(estaciones) {
  if (!estaciones.length) return "Sin horario informado";
  const cuts = [
    ...new Set(
      estaciones.map(
        (estacion) =>
          `${estacion?.hora_inicio?.slice(0, 5) || "—"} a ${estacion?.hora_fin?.slice(0, 5) || "—"}`
      )
    ),
  ];
  return cuts.length === 1 ? cuts[0] : "Varía por peaje";
}

export function daysFromFrequency(value) {
  const frequency = clean(value).trim().replace(/\s+/g, " ");
  if (/^(?:dia habil(?: siguiente)?|diari[ao]|cada dia(?: habil)?)$/.test(frequency)) return 1;
  const match = frequency.match(
    /^(?:cada )?(\d+|un|uno|dos|tres|cuatro|cinco|seis|siete|ocho|nueve|diez)(?: dias?(?: habil(?:es)?)?)?$/
  );
  if (!match) return null;
  const words = {
    un: 1,
    uno: 1,
    dos: 2,
    tres: 3,
    cuatro: 4,
    cinco: 5,
    seis: 6,
    siete: 7,
    ocho: 8,
    nueve: 9,
    diez: 10,
  };
  const days = words[match[1]] ?? Number(match[1]);
  return Number.isSafeInteger(days) && days > 0 ? days : null;
}
